import { html, attr, type Signal, MapSignal, Fragment } from '@tempots/dom'
import { type Controller } from '@tempots/beatui'
import { JSONSchemaForm } from '@tempots/beatui/json-schema'
import type {
  ActionDetail,
  ActionExecuteResponse,
  CostBreakdown,
} from '@/services/types'
import { ExecuteResult } from './execute-result'
import { ExecuteButton } from './execute-button'
import { CostEstimate } from './cost-estimate'
import { JSONSchemaCustomWidget } from '@/components/ui/json-schema-editor'
import { FilePickerWidget } from '@/components/ui'

export interface TryItPanelOptions {
  action: Signal<ActionDetail | null>
  costEstimate: Signal<CostBreakdown | null>
  calculating: Signal<boolean>
  executing: Signal<boolean>
  executeResult: Signal<
    | (ActionExecuteResponse & { success: true })
    | { success: false; error: string }
    | null
  >
  onCalculateCost: (parameters: unknown) => void
  onExecute: (parameters: unknown) => void
  controllerRef: { current: Controller<unknown> | undefined }
}

export function TryItPanel({
  action,
  costEstimate,
  calculating,
  executing,
  executeResult,
  onCalculateCost,
  onExecute,
  controllerRef,
}: TryItPanelOptions) {
  return html.div(
    attr.class('bg-white rounded-xl border border-gray-200 p-6 h-fit'),
    html.h2(attr.class('text-base font-semibold text-gray-900 mb-4'), 'Try It'),
    // Dynamic Parameters Form from inputSchema
    MapSignal(
      action.map((a) => a?.inputSchema),
      (schema) => {
        if (schema == null) {
          return html.p(
            attr.class('text-sm text-gray-500 mb-6'),
            'No parameters required for this action.'
          )
        }
        return JSONSchemaForm(
          {
            schema,
            validationMode: 'eager',
            customWidgets: [JSONSchemaCustomWidget, FilePickerWidget],
          },
          ({ Form, controller }) => {
            controller.signal.on((value) => console.log('!!!  form value', value))
            // Store controller reference for accessing form values
            controllerRef.current = controller
            return Fragment(
              html.div(
                attr.class('mb-6'),
                Form
                // html.pre(controller.signal.map((v) => JSON.stringify(v, null, 2)))
              ),
              html.div(
                attr.class('grid grid-cols-2 gap-4'),
                // Cost Estimate
                CostEstimate({
                  costEstimate,
                  calculating,
                  onCalculateCost: () => {
                    const value = controllerRef.current?.signal.get()
                    if (value != null) {
                      onCalculateCost(value)
                    }
                  },
                }),
                // Execute Button
                ExecuteButton({
                  executing,
                  onExecute: () => {
                    const value = controllerRef.current?.signal.get()
                    if (value != null) {
                      onExecute(value)
                    }
                  },
                })
              ),
              // Execute Result (after the grid)
              ExecuteResult({ executeResult })
            )
          }
        )
      }
    )
  )
}
